import React, { CSSProperties } from 'react';
import * as messages from '@radnuc/messages';
import * as thrift from 'thrift';

import './UserInvestigationDisplay.css'

import green_check_logo from './img/check_alt-green-32.png'
import red_x_logo from './img/x_alt-red-32.png'

export type UserInvestigationInfo = {
    time: Date;
    active: boolean;
    lastResult: messages.Rad.UserInvestigationResult | undefined
}

export interface UserInvestigationDisplayProps {
    userInvestigationInfo?: UserInvestigationInfo;
    linked_dialog_showing?: boolean | null;
    isSecondary?: boolean;
    style?: CSSProperties
}

export interface UserInvestigationDisplayState {
    user_inv_dropdown_show: boolean | null;
    user_inv_success_state: number;
}


async function send_user_investigation_command(command: string, duration_sec?: number){

    //console.log('User Inv Command: ' + command);

    let query = new messages.Rad.UserInvestigationCommand();

    if(command === 'PAST_5_MIN'){
        const d = new Date();
        const end_time = d.getTime();
        const start_time = end_time - 300000; //5 minutes
        query.startTime = start_time;
        query.endTime = end_time;
    } else if(command === 'NEXT_5_MIN'){
        const d = new Date();
        const start_time = d.getTime();
        const end_time = start_time + 300000; //5 minutes
        query.startTime = start_time;
        query.endTime = end_time;
    } else if(command === 'NEXT_N_SEC'){
        let duration_ms = 300000; //5 min default
        if (duration_sec !== undefined && duration_sec > 0) {
            duration_ms = duration_sec * 1000;
        }
        const d = new Date();
        const start_time = d.getTime();
        const end_time = start_time + duration_ms;
        query.startTime = start_time;
        query.endTime = end_time;
    } else if(command === 'CANCEL'){
        query.cancel = true;
    }

    let packed_data: Buffer | null = null;
    let transport = new thrift.TFramedTransport(undefined, function (msg, seqid) {
        if (!msg) return;

        // Remove 4-byte header from FramedTransport
        packed_data = msg.slice(4);
    });

    let protocol = new thrift.TBinaryProtocol(transport);
    query.write(protocol);
    transport.flush();

    if (packed_data === null)
        return;
        
    let port = window.location.port;
    if (window.location.port === '3000')
        port = '8301';
    let response = await fetch('http://' + window.location.hostname + ':'+port+'/TGW1hNlSwjaNFF96k4QQ9RXFNeiEqRab/' +
        `user_inv`, {
            method: 'POST',
            body: packed_data
        });

    if (response.status !== 200)
        throw new Error(`Bad return code: ${response.status}`);

}

export class UserInvestigationDisplay extends React.Component<UserInvestigationDisplayProps, UserInvestigationDisplayState, {}> {
    timeoutTimer: NodeJS.Timeout | null;

    constructor(props: UserInvestigationDisplayProps) {
        super(props)
        this.state = { user_inv_dropdown_show: false, user_inv_success_state: 0 }
        this.timeoutTimer = null;

        this.handleSelection = this.handleSelection.bind(this);
        this.handleSecondaryStartCancel = this.handleSecondaryStartCancel.bind(this);
        this.handleUserInvClick = this.handleUserInvClick.bind(this);
    }

    componentDidUpdate(prevProps: UserInvestigationDisplayProps) {
        if(this.props.userInvestigationInfo?.lastResult?.command !== prevProps.userInvestigationInfo?.lastResult?.command){
            if(this.props.userInvestigationInfo?.lastResult !== prevProps.userInvestigationInfo?.lastResult){
                if(this.props.userInvestigationInfo?.lastResult?.success){
                    this.displayUserInvSuccess();
                } else {
                    this.displayUserInvFail();
                }
            }
        }
        if (this.props.linked_dialog_showing && this.state.user_inv_dropdown_show) {
            this.setState(() => ({
                user_inv_dropdown_show: false
            }));
        }
    }

    componentWillUnmount() {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
    }

    displayUserInvSuccess() {
        this.setState(() => ({
            user_inv_success_state: 1
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(() => {
            this.setState(() => ({
                user_inv_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }

    displayUserInvFail() {
        this.setState(() => ({
            user_inv_success_state: 2
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(() => {
            this.setState(() => ({
                user_inv_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }

    displayUserInvBusy() {
        this.setState(() => ({
            user_inv_success_state: 3
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(() => {
            this.setState(() => ({
                user_inv_success_state: 2
            }));
            this.timeoutTimer = setTimeout(() => {
                this.setState(() => ({
                    user_inv_success_state: 0
                }));
                this.timeoutTimer = null;
            }, 3000);
        }, 3000);
    }

    handleUserInvClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            user_inv_dropdown_show: !state.user_inv_dropdown_show
        }));

        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        if (!this.state.user_inv_dropdown_show) {
            this.timeoutTimer = setTimeout(() => {
                this.setState(() => ({
                    user_inv_dropdown_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);

        }
    }


    async handleSelection(event: React.MouseEvent<HTMLElement>){
        let user_inv_in_progress = this.props.userInvestigationInfo?.active;
        const selected = event.currentTarget.innerHTML;

        try{
            if(!user_inv_in_progress){
                if (selected === 'Past 5 min') {
                    this.setState(() => ({
                        user_inv_dropdown_show: false
                    }));
                    this.displayUserInvBusy();
                    await send_user_investigation_command('PAST_5_MIN');
                }
                if (selected === 'Next 5 min') {
                    this.setState(() => ({
                        user_inv_dropdown_show: false
                    }));
                    this.displayUserInvBusy();
                    await send_user_investigation_command('NEXT_5_MIN');
                }
            } else {
                if (selected === 'Cancel Current') {
                    this.setState(() => ({
                      user_inv_dropdown_show: false
                    }));
                    this.displayUserInvBusy();
                    await send_user_investigation_command('CANCEL');
                }
            }
        } catch(err) {
            console.log(err)
            this.setState(() => ({
                user_inv_dropdown_show: false
            }));
            this.displayUserInvFail();
            return
        }
    }

    async handleSecondaryStartCancel(event: React.MouseEvent<HTMLElement>){
        let user_inv_in_progress = this.props.userInvestigationInfo?.active;

        try{
            if(!user_inv_in_progress){
                this.displayUserInvBusy();
                await send_user_investigation_command('NEXT_N_SEC',180);
            } else {
                this.displayUserInvBusy();
                await send_user_investigation_command('CANCEL');
            }
        } catch(err) {
            console.log(err)
            this.displayUserInvFail();
            return
        }
    }


    render() {

        if(!this.props.isSecondary){
            //PRIMARY BUTTON
            let userInvMenuItems;
            if(this.props.userInvestigationInfo?.active){
                userInvMenuItems =
                <>
                    <div className={"inv-menu-item"} onClick={this.handleSelection}>Cancel Current</div>
                </>
            } else {
                userInvMenuItems =
                <>
                    <div className={"inv-menu-item"} onClick={this.handleSelection}>Next 5 min</div>
                    <div className={"inv-menu-item"} onClick={this.handleSelection}>Past 5 min</div>
                </>
            }
            //Buttons
            let user_inv_dropdown;
            if (!this.props.linked_dialog_showing && this.state.user_inv_dropdown_show) {
                user_inv_dropdown =
                    <div className="inv-user-inv-dropdown-container inv-menu-item" style={{ display: 'flex', position: 'absolute' }}>
                        <div className="plot-title dropdown user-inv-dropdown-surrogate"></div>
                        <div id="user-inv-select-dropdown-content" className="dropdown-content user-inv-dropdown show" style={this.props.style}>
                            <div className="plot-header" style={{ background: 'orange' }}>
                                <label className="plot-title " style={{ color: 'black', fontSize: '1em', paddingLeft:'5px'}}>Manual Investigation</label>
                            </div>
                            {userInvMenuItems}
                        </div>
                    </div>
            }

            let user_inv_status;
            if (this.state.user_inv_success_state === 1) {
                user_inv_status =
                    <div className="inv-user-inv round-skinny-button dropdownevent plot-title dropdown" id="user-inv-select-dropdown" style={{ width:'58px'}}>
                        <img src={green_check_logo} alt="Success" className="inv-user-inv-success inv-menu-button" style={{ height:'21px'}}></img>
                    </div>
            } else if (this.state.user_inv_success_state === 2) {
                user_inv_status =
                    <div className="inv-user-inv round-skinny-button dropdownevent plot-title dropdown" id="user-inv-select-dropdown" style={{ width:'58px'}}>
                        <img src={red_x_logo} alt="Fail" className="inv-user-inv-fail inv-menu-button" style={{ height:'21px'}}></img>
                    </div>
            } else if (this.state.user_inv_success_state === 3) {
                user_inv_status =
                    <div className="inv-user-inv round-skinny-button dropdownevent plot-title dropdown" id="user-inv-select-dropdown" style={{ width:'58px'}}>
                        <div className="loader" style={{height:'17px',width:'17px'}}/>
                    </div>
            } else {
                let button_title='START';
                let button_class=''
                if(this.props.userInvestigationInfo?.active){
                    button_title='CANCEL'
                    button_class = ' active'
                }
                if (this.state.user_inv_dropdown_show) {
                    user_inv_status =
                        <div className={"inv-user-inv-open round-skinny-button dropdownevent plot-title dropdown"+button_class} id="user-inv-select-dropdown" style={{ cursor: 'pointer', width:'58px'}} onClick={this.handleUserInvClick}>{button_title}</div>
                } else {
                    user_inv_status =
                        <div className={"inv-user-inv round-skinny-button dropdownevent plot-title dropdown"+button_class} id="user-inv-select-dropdown" style={{ cursor: 'pointer',width:'58px' }} onClick={this.handleUserInvClick}>{button_title}</div>

                }
            }

            let user_inv_button =
                <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                    <div id="user-inv-select-dropdown" className="dropdown" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        {user_inv_dropdown}
                        <div className="inv-user-inv-container inv-menu-item">
                            {user_inv_status}
                        </div>
                        <div className="inv-export-all-hidden" style={{ display: 'none'}} onClick={this.handleSelection}/>
                    </div>
                </div>


            return (user_inv_button);

        } else {

            let user_inv_status;
            if (this.state.user_inv_success_state === 1) {
                user_inv_status =
                    <div className="inv-user-inv round-skinny-button plot-title" id="user-inv-select-dropdown" style={{ display: 'flex', height:'40px', width:'100%', transition:'none'}}>
                        <img src={green_check_logo} alt="Success" className="inv-user-inv-success inv-menu-button" style={{ height:'21px'}}></img>
                    </div>
            } else if (this.state.user_inv_success_state === 2) {
                user_inv_status =
                    <div className="inv-user-inv round-skinny-button plot-title" id="user-inv-select-dropdown" style={{ display: 'flex', height:'40px', width:'100%', transition:'none'}}>
                        <img src={red_x_logo} alt="Fail" className="inv-user-inv-fail inv-menu-button" style={{ height:'21px'}}></img>
                    </div>
            } else if (this.state.user_inv_success_state === 3) {
                user_inv_status =
                    <div className="inv-user-inv round-skinny-button plot-title" id="user-inv-select-dropdown" style={{ display: 'flex', height:'40px', width:'100%', transition:'none'}}>
                        <div className="loader" style={{height:'17px',width:'17px'}}/>
                    </div>
            } else {
                let button_title='START SCAN';
                let button_class=''
                if(this.props.userInvestigationInfo?.active){
                    button_title='CANCEL SCAN'
                    button_class = ' active-secondary'
                }
                user_inv_status =
                    <div className={"inv-user-inv round-skinny-button plot-title "+button_class} id="user-inv-select-dropdown"
                        style={{ cursor: 'pointer', height:'40px', width:'100%',fontSize:'1.5em', transition:'none', fontWeight: 500}}
                        onClick={this.handleSecondaryStartCancel}>{button_title}</div>
            }

            let user_inv_button =
                <div style={{ display: 'flex', alignItems: 'center', position: 'relative', transition:'0s'}}>
                    <div id="user-inv-select-dropdown" className="dropdown" style={{ display: 'flex', flex: 1, alignItems: 'center', flexDirection: 'column',
                        paddingLeft: '5px', paddingBottom:'10px' }}>
                        <div className="inv-user-inv-container inv-menu-item" style={{ display: 'flex', width:'100%'}}>
                            {user_inv_status}
                        </div>
                    </div>
                </div>


            return (user_inv_button);
        }
    }
}
export default UserInvestigationDisplay
